// import React, { useEffect, useState } from "react";
// import AppHeader from "./Header";
// import {
//   AppShell,
//   Header,
//   Navbar,
//   ActionIcon,
//   ScrollArea,
// } from "@mantine/core";
// import {
//   IconArrowBadgeRight,
//   IconBadge,
//   IconBell,
//   IconCircleCheck,
//   IconEdit,
//   IconFileReport,
//   IconFileTypePdf,
//   IconHome,
//   IconLayoutSidebarLeftCollapse,
//   IconLayoutSidebarRightCollapse,
//   IconLock,
//   IconPlus,
//   IconProgress,
//   IconReport,
//   IconReportAnalytics,
//   IconTimeline,
//   IconUsers,
// } from "@tabler/icons-react";
// import { IconFile } from "@tabler/icons-react";
// import { getUnseenNotificationsCount } from "../apis/notificationapi";
// import { getCookiesSession } from "../apis/cookiesSession";

// const SideNav = ({ appContent }) => {
//   const userData = JSON.parse(getCookiesSession("userData"));
//   const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
//   const [unseen, setUnseen] = useState(null);

//   const filter = {
//     role: userData?.loginAs, // Use optional chaining to prevent errors if `userData` is null or undefined
//     department: userData?.department,
//   };

//   useEffect(() => {
//     const getUnseenCount = async () => {
//       try {
//         const response = await getUnseenNotificationsCount({ filter });
//         setUnseen(response?.count || 0);
//       } catch (error) {
//         console.error("Error fetching unseen notifications count:", error);
//       }
//     };

//     // Ensure filter fields are valid before making the request
//     getUnseenCount();
//   }, [filter.role, filter.department]);

//   return (
//     <>
//       <AppShell
//         navbar={
//           <Navbar
//             style={{ backgroundColor: "#F1F4FA" }}
//             width={{ base: sidebarCollapsed ? 50 : 240 }}
//             height="calc(100vh - 65px)"
//           >
//             <Navbar.Section grow component={ScrollArea}>
//               <div className="flex flex-col">
//                 <div className="flex justify-end mt-2">
//                   <ActionIcon
//                     color="#1b6f8d"
//                     onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
//                     style={{ cursor: "pointer", marginRight: "9%" }}
//                   >
//                     {sidebarCollapsed ? (
//                       <IconLayoutSidebarRightCollapse
//                         color="#1b6f8d"
//                         size={25}
//                       />
//                     ) : (
//                       <IconLayoutSidebarLeftCollapse
//                         color="#1b6f8d"
//                         size={25}
//                       />
//                     )}
//                   </ActionIcon>
//                 </div>
//                 {!sidebarCollapsed && (
//                   <div className="flex flex-col p-3">
//                     <div className="space-y-3">
//                       <div className="flex-1">
//                         <ul className=" pb-4 space-y-3 text-sm">
//                           {userData.loginAs !== "Ob-Auditor" && (
//                             <li className="rounded-sm">
//                               <a
//                                 href="/dashboard"
//                                 className="flex items-center p-2 space-x-4 rounded-md"
//                               >
//                                 <IconHome
//                                   style={{ padding: "2px" }}
//                                   color="#1b6f8d"
//                                   size={25}
//                                 />
//                                 <span style={{ fontWeight: "500" }}>
//                                   dashboard
//                                 </span>
//                               </a>
//                             </li>
//                           )}
//                           {(userData.loginAs === "Ob-DeptUser" ||
//                             userData.loginAs === "Ob-DeptAdmin" ||
//                             userData.loginAs === "Ob-Admin" ||
//                             userData.loginAs === "Ob-Auditor") && (
//                             <li className="rounded-sm">
//                               <a
//                                 href="/notifications"
//                                 className="flex justify-between"
//                               >
//                                 <div className="flex  p-2 space-x-4 rounded-md">
//                                   <IconBell
//                                     style={{ padding: "2px" }}
//                                     color="#1b6f8d"
//                                     size={25}
//                                   />
//                                   <span style={{ fontWeight: "500" }}>
//                                     notifications
//                                   </span>
//                                 </div>
//                                 <div className="flex justify-center mt-2">
//                                   <span
//                                     className="rounded  text-center mr-2"
//                                     style={{
//                                       borderRadius: "50%",
//                                       textAlign: "center",
//                                       fontWeight: "500",
//                                       backgroundColor: "#1b6f8d",
//                                       width: "22px",
//                                       height: "22px",
//                                       lineHeight: "20px",
//                                       color: "white",
//                                       padding: "1px",
//                                     }}
//                                   >
//                                     {unseen !== null && unseen}
//                                   </span>
//                                 </div>
//                               </a>
//                             </li>
//                           )}
//                           {(userData.loginAs === "Ob-Admin" ||
//                             userData.loginAs === "Ob-Editor" ||
//                             userData.loginAs === "Ag-Editor" ||
//                             userData.loginAs === "Ob-DeptAdmin") && (
//                             <li className="rounded-sm">
//                               <a
//                                 href="/new"
//                                 className="flex items-center p-2 space-x-4 rounded-md"
//                               >
//                                 <IconPlus
//                                   style={{ padding: "2px" }}
//                                   color="#1b6f8d"
//                                   size={25}
//                                 />
//                                 <span style={{ fontWeight: "500" }}>
//                                   new obligation
//                                 </span>
//                               </a>
//                             </li>
//                           )}
//                           {/* {userData.loginAs === "Ob-DeptAdmin" && (
//                             <li className="rounded-sm">
//                               <a
//                                 href="/draft"
//                                 className="flex items-center p-2 space-x-4 rounded-md"
//                               >
//                                 <IconEdit
//                                   style={{ padding: "2px" }}
//                                   color="#1b6f8d"
//                                   size={25}
//                                 />
//                                 <span style={{ fontWeight: "500" }}>
//                                   draft obligations
//                                 </span>
//                               </a>
//                             </li>
//                           )} */}
//                           {/* {userData.loginAs === "Ob-DeptAdmin" && (
//                             <li className="rounded-sm">
//                               <a
//                                 href="/acceptobligation"
//                                 className="flex items-center p-2 space-x-4 rounded-md"
//                               >
//                                 <IconCircleCheck
//                                   style={{ padding: "2px" }}
//                                   color="#1b6f8d"
//                                   size={25}
//                                 />
//                                 <span style={{ fontWeight: "500" }}>
//                                   accept obligations
//                                 </span>
//                               </a>
//                             </li>
//                           )} */}
//                           {(userData.loginAs === "Ob-DeptUser" ) && (
//                             <li className="rounded-sm">
//                               <a
//                                 href="/assigned"
//                                 className="flex items-center p-2 space-x-4 rounded-md"
//                               >
//                                 <IconReport
//                                   style={{ padding: "2px" }}
//                                   color="#1b6f8d"
//                                   size={25}
//                                 />
//                                 <span style={{ fontWeight: "500" }}>
//                                   my obligations
//                                 </span>
//                               </a>
//                             </li>
//                           )}
//                           {(userData.loginAs === "Ob-DeptUser" ) && (
//                             <li className="rounded-sm">
//                               <a
//                                 href="/actioned"
//                                 className="flex items-center p-2 space-x-4 rounded-md"
//                               >
//                                 <IconProgress
//                                   style={{ padding: "2px" }}
//                                   color="#1b6f8d"
//                                   size={25}
//                                 />
//                                 <span style={{ fontWeight: "500" }}>
//                                   actioned obligations
//                                 </span>
//                               </a>
//                             </li>
//                           )}
//                           {(userData.loginAs === "Ob-Editor" ||
//                             userData.loginAs === "Ob-DeptAdmin" ||
//                             userData.loginAs === "Ob-CXO" ||
//                             userData.loginAs === "Ag-Editor" ||
//                             userData.loginAs === "Ob-CEO" ||
//                             userData.loginAs === "Ob-COO" ||
//                             userData.loginAs === "Ob-Admin" ||
//                             userData.loginAs === "Ob-Auditor") && (
//                             <li className="rounded-sm">
//                               <a
//                                 href="/obligationtracker"
//                                 className="flex items-center p-2 space-x-4 rounded-md"
//                               >
//                                 <IconReportAnalytics
//                                   style={{ padding: "2px" }}
//                                   color="#1b6f8d"
//                                   size={25}
//                                 />
//                                 <span style={{ fontWeight: "500" }}>
//                                   obligations monitor
//                                 </span>
//                               </a>
//                             </li>
//                           )}
//                           {(userData.loginAs === "Ob-Editor" ||
//                             userData.loginAs === "Ob-Admin" ||
//                             userData.loginAs === "Ob-DeptAdmin" ||
//                             userData.loginAs === "Ag-Editor") && (
//                             <li className="rounded-sm">
//                               <a
//                                 href="/docslocker"
//                                 className="flex items-center p-2 space-x-4 rounded-md"
//                               >
//                                 <IconLock
//                                   style={{ padding: "2px" }}
//                                   color="#1b6f8d"
//                                   size={25}
//                                 />
//                                 <span style={{ fontWeight: "500" }}>
//                                   agreements locker
//                                 </span>
//                               </a>
//                             </li>
//                           )}
//                           {/* <li className="rounded-sm">
//                             <a
//                               href="/documents"
//                               className="flex items-center p-2 space-x-4 rounded-md"
//                             >
//                               <IconFile
//                                 style={{ padding: "2px" }}
//                                 color="#1b6f8d"
//                                 size={25}
//                               />
//                               <span style={{ fontWeight: "500" }}>
//                                 documents
//                               </span>
//                             </a>
//                           </li> */}
//                           {userData.loginAs === "Ob-Admin" && (
//                             <li className="rounded-sm">
//                               <a
//                                 href="/team"
//                                 className="flex items-center p-2 space-x-4 rounded-md"
//                               >
//                                 <IconUsers
//                                   style={{ padding: "2px" }}
//                                   color="#1b6f8d"
//                                   size={25}
//                                 />
//                                 <span style={{ fontWeight: "500" }}>
//                                   team manager
//                                 </span>
//                               </a>
//                             </li>
//                           )}
//                         </ul>
//                       </div>
//                     </div>
//                   </div>
//                 )}
//               </div>
//             </Navbar.Section>
//           </Navbar>
//         }
//         header={
//           <Header height={65} style={{ background: "#FFFFFF" }}>
//             <AppHeader />
//           </Header>
//         }
//       >
//         <div
//           style={{
//             backgroundColor: "#FFFFFF",
//             minHeight: "calc(100vh - 100px)",
//           }}
//         >
//           {appContent}
//         </div>
//       </AppShell>
//     </>
//   );
// };

// export default SideNav;

// // 21
// {
//   /* <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 18">
//     <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 17V1m0 0L1 4m3-3 3 3m4-3h6l-6 6h6m-7 10 3.5-7 3.5 7m-6.125-2H16"/>
// </svg> */
// }

// // 31
// // <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 17 14">
// //     <path d="M16 2H1a1 1 0 0 1 0-2h15a1 1 0 1 1 0 2Zm0 6H1a1 1 0 0 1 0-2h15a1 1 0 1 1 0 2Zm0 6H1a1 1 0 0 1 0-2h15a1 1 0 0 1 0 2Z"/>
// // </svg>

import React, { useEffect, useState } from "react";
import AppHeader from "./Header";
import { AppShell, Header, Navbar, ActionIcon, ScrollArea } from "@mantine/core";
import {
  IconLayoutSidebarLeftCollapse,
  IconLayoutSidebarRightCollapse,
  IconUsers, // Keeping this for Team Manager
  IconUserCircle,
} from "@tabler/icons-react";
import { getUnseenNotificationsCount } from "../apis/notificationapi";
import { getCookiesSession } from "../apis/cookiesSession";
import { LinksGroup } from "../pages/NavbarLinkGroup"; 
import "./sidebar.css";
import {
  MyBagIcon, 
  DocLockerIcon, 
  NotificationIcon, 
  PlusIcon, 
  TemplatesIcon, 
  HomeIcon, 
  TickIcon, 
  ActionedIcon 
} from "../../src/new-icons/icon";

const SideNav = ({ appContent }) => {
  // Logic from original code
  const userData = JSON.parse(getCookiesSession("userData") || "{}");
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [unseen, setUnseen] = useState(null);

  const role = userData?.loginAs;
  const department = userData?.department;

  useEffect(() => {
    const getUnseenCount = async () => {
      try {
        const response = await getUnseenNotificationsCount({ 
            filter: { role, department } 
        });
        setUnseen(response?.count || 0);
      } catch (error) {
        console.error("Error fetching unseen notifications count:", error);
      }
    };

    if (role) getUnseenCount();
  }, [role, department]);

  // Unified Menu Data with your specific role-based logic
  const menuData = [
    {
      label: "Overview",
      icon: HomeIcon,
      link: "/dashboard",
      section: "MENU",
      hidden: role === "Ob-Auditor",
    },
    {
      label: "Alerts",
      icon: NotificationIcon,
      link: "/notifications",
      section: "MENU",
      hasNumber: unseen !== null ? unseen : 0,
      hidden: !["Ob-DeptUser", "Ob-DeptAdmin", "Ob-Admin", "Ob-Auditor"].includes(role),
    },
    {
      label: "Create",
      icon: PlusIcon,
      link: "/new",
      section: "MENU",
      hidden: !["Ob-Admin", "Ob-Editor", "Ag-Editor", "Ob-DeptAdmin"].includes(role),
    },
    {
      label: "Obligations Register",
      icon: TemplatesIcon,
      link: "/assigned",
      section: "OTHERS",
      hidden: role !== "Ob-DeptUser",
    },
    {
      label: "Actioned Obligations",
      icon: ActionedIcon,
      link: "/actioned",
      section: "OTHERS",
      hidden: role !== "Ob-DeptUser",
    },
    {
      label: "Obligations Monitor",
      icon: MyBagIcon,
      link: "/obligationtracker",
      section: "OTHERS",
      hidden: !["Ob-Editor", "Ob-DeptAdmin", "Ob-CXO", "Ag-Editor", "Ob-CEO", "Ob-COO", "Ob-Admin", "Ob-Auditor"].includes(role),
    },
    {
      label: "Contracts List",
      icon: DocLockerIcon,
      link: "/docslocker",
      section: "OTHERS",
      hidden: !["Ob-Editor", "Ob-Admin", "Ob-DeptAdmin", "Ag-Editor"].includes(role),
    },
    {
        label: "Team Manager",
        icon: IconUsers, // Using Tabler icon as fallback if no custom one exists
        link: "/team",
        section: "OTHERS",
        hidden: role !== "Ob-Admin",
    },
    {
        label: "Users",
        icon: IconUserCircle,
        link: "/users",
        section: "OTHERS",
        hidden: role !== "Ob-Admin",
    },
  ].filter(item => !item.hidden);

  const menuItems = menuData.filter(i => i.section === "MENU");
  const otherItems = menuData.filter(i => i.section === "OTHERS");

  return (
    <AppShell
      navbar={
        <Navbar
          className="sidebar-container"
          width={{ base: sidebarCollapsed ? 60 : 250 }}
          height="calc(100vh - 65px)"
          style={{ backgroundColor: "#eef2f3", transition: "width 0.3s ease" }}
        >
          <Navbar.Section grow component={ScrollArea} className="pt-4">
            <div className="flex flex-col">
              {/* Sidebar Toggle */}
              <span className="flex justify-end pr-3 mb-2">
                <ActionIcon 
                  onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
                  variant="transparent"
                  className="pb-3"
                >
                  {sidebarCollapsed ? (
                    <IconLayoutSidebarRightCollapse color="#649fb1" size={23} />
                  ) : (
                    <IconLayoutSidebarLeftCollapse color="#649fb1" size={23} />
                  )}
                </ActionIcon>
              </span>

              {!sidebarCollapsed && (
                <div className="animate-fade-in px-3" style={{marginTop: "-47px"}}>
                  <div className="sidebar-heading text-xs font-bold text-gray-400 mb-2">MENU</div>
                  {menuItems.map((item) => (
                    <LinksGroup {...item} key={item.label} />
                  ))}

                  {otherItems.length > 0 && (
                    <>
                      <div className="sidebar-heading text-xs font-bold text-gray-400 mt-6 mb-2">OTHERS</div>
                      {otherItems.map((item) => (
                        <LinksGroup {...item} key={item.label} />
                      ))}
                    </>
                  )}
                </div>
              )}
            </div>
          </Navbar.Section>
        </Navbar>
      }
      header={
        <Header height={65} style={{ background: "#FFFFFF", borderBottom: "1px solid #eaeaea" }}>
          <AppHeader />
        </Header>
      }
    >
      <div style={{ backgroundColor: "#FFFFFF", minHeight: "calc(100vh - 100px)" }}>
        {appContent}
      </div>
    </AppShell>
  );
};

export default SideNav;